// extracted by mini-css-extract-plugin
export default {"static-hero":"ZEoQ7UJb7JO3x7sws3_7"};